import { partnerEnabledForExpertUniversity, useExpertUniversityConfiguration } from "@expert/expert-university";
import { useFeatures, type WorkspaceFeatures } from "@expert/features";
import { NotificationCenter } from "@expert/solve-tools";
import { Group, useMatches } from "@mantine/core";
import { env } from "@/config";
import { PartnerSelectionMenu } from "@/expert-university/components/PartnerSelectionMenu";
import { AgentStatus, FeedbackButton, Profile } from "@/header";
import { usePartnerConfig, usePartnerFeatureConfigured } from "@/partner/usePartnerConfig";
import { useActiveTask, useAgentStore, usePartner } from "@/sdk";
import EvlConnectionStatus from "../evl/EvlConnectionStatus";

export function HeaderControls() {
    const agentPartner = usePartner();
    const { allowedPartners } = useExpertUniversityConfiguration();
    const currentActivity = useAgentStore((state) => state.activity);
    const { feedback, feedbackType } = usePartnerFeatureConfigured();
    const { trainingAgentActivity } = usePartnerConfig();
    const activeTask = useActiveTask();
    const {
        features: { isOutageAlertInfoEnabled, ignoreEvl },
    } = useFeatures<WorkspaceFeatures>();
    const buttonGroupGap = useMatches({
        base: "xs",
        md: "sm",
        lg: "md",
    });

    return (
        <Group wrap="nowrap" align="center" pr="lg" gap="lg">
            {allowedPartners.length > 1 &&
                currentActivity === "Training" &&
                partnerEnabledForExpertUniversity(agentPartner, env.channel) &&
                !activeTask && <PartnerSelectionMenu />}
            <Group gap="0" id="header-status-group" wrap="nowrap" align="center">
                {!ignoreEvl && env.channel !== "chat" && <EvlConnectionStatus />}
            </Group>
            <Group gap={buttonGroupGap} id="header-controls-group" wrap="nowrap" align="center">
                {isOutageAlertInfoEnabled && <NotificationCenter />}
                {feedback && feedbackType && (
                    <FeedbackButton
                        feedbackType={feedbackType}
                        isTraining={
                            trainingAgentActivity &&
                            currentActivity === trainingAgentActivity &&
                            partnerEnabledForExpertUniversity(agentPartner, env.channel)
                        }
                    />
                )}
                <AgentStatus />
                <Profile isProdMode={env.isProdMode} commitHash={env.commitHash} />
            </Group>
        </Group>
    );
}
